module.exports = __webpack_public_path__ + "static/images/offer.2EOW_4A.svg";